import * as React from "react";

import type * as Ruff from "@khanacademy/ruff-wasm";

export type CheckFn = (text: string) => Promise<Ruff.Diagnostic[]>;

/**
 * A hook that manages the lifecycle of the Ruff linter. It returns an object
 * with a single function, `check`, that takes some code and returns a diagnostic
 */
export const useRuffLinter = (): {check: CheckFn} => {
    const workspacePromise = React.useMemo(
        () =>
            import("@khanacademy/ruff-wasm").then(
                (ruff) => new ruff.Workspace({"line-length": 79}),
            ),
        [],
    );

    React.useEffect(() => {
        // Clean up the workspace on unmount
        return () => {
            workspacePromise?.then((workspace) => workspace.free());
        };
    }, [workspacePromise]);

    const check = React.useCallback(
        (code: string) =>
            workspacePromise?.then((workspace) => workspace.check(code)) ??
            Promise.resolve([]),
        [workspacePromise],
    );

    return {check};
};
